import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { StudentsDataGridCols } from './data-grid-cols'
import { toast } from 'react-toastify';
import { BULK_UPLOAD_STUDENTS, DELETE_INDIVIDUAL_USER, GET_INDIVIDUAL_USER, GET_INDIVIDUAL_USER_FILTER } from '../../../app/service/users.service';
import { GET_TOTAL_SCHOOLS } from '../../../app/service/school.service';
import FormBuilder from '../../../components/form-builder';
import { DataTable } from '../../../components/data-table';

export const IndividualStudentsList = () => {
    const [pageArray, setPageNumbers] = useState([]);
    const [activePage, setActivePage] = useState<any>();
    const [studentList, setStudentList] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState<any>({});
    const [preparedSearchData, setPreparedSearchData] = useState<any>({});
    const usersForm = useRef<any>({});
    const location = useLocation().pathname;
    const isIndividualStudent = location.includes('individual-student');
    const search = useLocation().search;
    const currentPageNumber: any = new URLSearchParams(search).get('page');
    const [accessObjectsList, setAccessObjectsList] = useState<any>([]);
    const filteredData = [
        { name: 'Mobile Number', value: 'mobile_number' },
        { name: 'Whatsapp Number', value: 'whatsapp_number' },
        { name: 'State', value: 'state' },
        { name: 'City', value: 'city_village' },
        { name: 'Date of Registration', value: 'date_of_registration' },
        { name: 'Taluka', value: 'taluka' },
        { name: 'Gender', value: 'gender' },
        { name: 'Address', value: 'address' },
        { name: 'Blood Group', value: 'blood_group' },
        { name: 'District', value: 'district' },
        { name: 'Date of Birth', value: 'date_of_birth' },
        { name: 'Pincode', value: 'pin_code' },
    ];
    const history = useHistory();

    useEffect(() => {
        getStudents();
        const accessObjectsData: any = localStorage.getItem("access_objects_data");
        setAccessObjectsList(JSON.parse(accessObjectsData));
        handleIndividualStudentsCols(JSON.parse(accessObjectsData));
    }, []);

    function getStudents() {
        const activePageNumber = currentPageNumber > 0 ? (currentPageNumber - 1) : 0;
        setLoading(true);
        GET_INDIVIDUAL_USER('STUDENT', activePageNumber, {}).then((res: any) => {
            // GET_INDIVIDUAL_USER('STUDENT', 0).then((res: any) => {
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    setActivePage(currentPageNumber ? currentPageNumber : 1);
                    const data = res.rows;
                    data.forEach((element: any) => {
                        element.individual_student = element.name;
                        element.account_type = element?.account_type?.charAt(0).toUpperCase() + element?.account_type?.slice(1).toLowerCase();

                    });
                    setStudentList(data);
                    const pageNumbers = Math.ceil(res.count / 10);
                    const pageArray: any = [];
                    for (let i = 1; i <= pageNumbers; i++) {
                        pageArray.push(i);
                    }
                    setPageNumbers(pageArray);
                    setLoading(false);
                }
            }
        });
    }

    const onPageChange = (data: any) => {
        if (data) {
            history.push(`/dashboard/individual-student/list?page=${data}`);
        }
        setActivePage(data);
        const pageNumber = data - 1;
        setLoading(true);
        GET_INDIVIDUAL_USER('STUDENT', pageNumber, preparedSearchData ? preparedSearchData : {}).then((res: any) => {
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    const data = res['rows'];
                    data.forEach((element: any) => {
                        element.individual_student = element.name;
                        element.account_type = element?.account_type?.charAt(0).toUpperCase() + element?.account_type?.slice(1).toLowerCase();

                    });
                    setStudentList(data);
                    setLoading(false);
                }

            }
        });
    }

    const onEditStudent = (data: any) => {
        history.push(`/dashboard/individual-student/form/${data.id}`);
    }

    const onDeleteStudent = (data: any) => {
        setLoading(true);
        const id = data.user_code;
        DELETE_INDIVIDUAL_USER(id).then((res: any) => {
            if (res.status === 'fail') {
                toast.error(res.message);
                setLoading(false);
            } else {
                setLoading(false);
                toast.success("Students Deleted Successfully");
                getStudents();
            }
        });
    }

    function handleUploadBulkUpload(e: any) {
        if (e.target.files && e.target.files[0]) {
            let formData = new FormData();
            formData.append('file', e.target.files[0], e.target.files[0].name);
            setLoading(true);

            BULK_UPLOAD_STUDENTS(formData).then((res: any) => {
                if (res.status === 'fail') {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    setLoading(false);
                    toast.success("Bulk Upload Successfully");
                    getStudents();
                }
            });
        }

    }

    const handleInput = (data: any) => {
        setSearchData(data);
    };

    function handleSearch() {
        const data = { ...searchData.value };
        if (data.searchFilter === 'state') {
            data.state = data.search_name;
        } else if (data.searchFilter === 'city_village') {
            data.city_village = data.search_name;
        } else if (data.searchFilter === 'mobile_number') {
            data.mobile_number = data.search_name;
        } else if (data.searchFilter === 'whatsapp_number') {
            data.whatsapp_number = data.search_name;
        } else if (data.searchFilter === 'taluka') {
            data.taluka = data.search_name;
        } else if (data.searchFilter === 'gender') {
            data.gender = data.search_name;
        }
        // else if (data.searchFilter === 'email_id') {
        //     data.email_id = data.search_name;
        // } 
        else if (data.searchFilter === 'date_of_registration') {
            const date_of_registration = data.search_name;
            if (data.search_name) {
                const preparedDate = date_of_registration.split('-');
                const date = preparedDate[0];
                const month = preparedDate[1];
                const year = preparedDate[2];
                data.date_of_registration = year + '-' + month + '-' + date + 'T00:00:00Z';
            }
            // data.date_of_registration = data.search_name;
        } else if (data.searchFilter === 'pan_number') {
            data.pan_number = data.search_name;
        } else if (data.searchFilter === 'address') {
            data.address = data.search_name;
        } else if (data.searchFilter === 'blood_group') {
            data.blood_group = data.search_name;
        } else if (data.searchFilter === 'date_of_birth') {
            const date_of_birth = data.search_name;
            if (data.search_name) {
                const preparedDate = date_of_birth.split('-');
                const date = preparedDate[0];
                const month = preparedDate[1];
                const year = preparedDate[2];
                data.date_of_birth = year + '-' + month + '-' + date;
            }
            // data.date_of_birth = data.search_name;
        } else if (data.searchFilter === 'district') {
            data.district = data.search_name;
        } else if (data.searchFilter === 'pin_code') {
            data.pin_code = data.search_name;
        }
        delete data.search_name;
        delete data.searchFilter;
        if (data) {
            setLoading(true);
            for (const key of Object.keys(data)) {
                if (data[key] === "") {
                    delete data[key];
                }
            }
            setPreparedSearchData(data);
            GET_INDIVIDUAL_USER_FILTER(data).then((res: any) => {
                if (res.status === 'fail') {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    history.push(`/dashboard/individual-student/list?page=${1}`);
                    setActivePage(1);
                    const data = res.rows;
                    data.forEach((element: any) => {
                        element.individual_student = element.name;
                        element.account_type = element?.account_type?.charAt(0).toUpperCase() + element?.account_type?.slice(1).toLowerCase();

                    });
                    setStudentList(data);
                    const pageNumbers = Math.ceil(res.count / 10);
                    const pageArray: any = [];
                    for (let i = 1; i <= pageNumbers; i++) {
                        pageArray.push(i);
                    }
                    setPageNumbers(pageArray);
                    setLoading(false);
                }
            });
        }
    }

    function handleRefresh() {
        const data = searchData
        data.value = {};
        setSearchData({ ...data });
        setPreparedSearchData({});
        getStudents();
        usersForm.current.reset();
    }


    const handleFilterChange = (e: any) => {
        const data = { ...searchData.value };
        setSearchData(data);
    }

    const handleIndividualStudentsCols = (accessObjectsList: any) => {
        const preparedData = accessObjectsList?.filter((el: any) => el.object_code === "INDIVIDUAL");
        if (preparedData?.length > 0) {
            for (let i = 0; i < preparedData[0].child.length; i++) {
                for (let j = 0; j < StudentsDataGridCols.length; j++) {
                    if (preparedData[0].child[i].object_code === "INDIVIDUAL-STUDENTS-EDIT" && preparedData[0].child[i].p_read === 1) {
                        if (StudentsDataGridCols[j].title == "Actions") {
                            StudentsDataGridCols[j].isEdit = true;
                        }

                    }

                    if (preparedData[0].child[i].object_code === "INDIVIDUAL-STUDENTS-DELETE" && preparedData[0].child[i].p_read === 1) {
                        if (StudentsDataGridCols[j].title == "Actions") {
                            StudentsDataGridCols[j].isDelete = true;
                        }
                    }
                    if (preparedData[0].child[i].object_code === "INDIVIDUAL-STUDENTS-SET-PASSWORD" && preparedData[0].child[i].p_read === 1) {
                        if (StudentsDataGridCols[j].title == "Actions") {
                            StudentsDataGridCols[j].setPassword = true;
                        }
                    }
                    if (preparedData[0].child[i].object_code === "INDIVIDUAL-STUDENTS-RESET-PROGRESS" && preparedData[0].child[i].p_read === 1) {
                        if (StudentsDataGridCols[j].title == "Actions") {
                            StudentsDataGridCols[j].resetProgress = true;
                        }
                    }

                    if ((preparedData[0].child[i].object_code === "INDIVIDUAL-STUDENTS-RESET-PROGRESS" && preparedData[0].child[i].p_read === 1) ||
                        (preparedData[0].child[i].object_code === "INDIVIDUAL-STUDENTS-SET-PASSWORD" && preparedData[0].child[i].p_read === 1) ||
                        (preparedData[0].child[i].object_code === "INDIVIDUAL-STUDENTS-DELETE" && preparedData[0].child[i].p_read === 1) ||
                        (preparedData[0].child[i].object_code === "INDIVIDUAL-STUDENTS-EDIT" && preparedData[0].child[i].p_read === 1)) {
                        if (StudentsDataGridCols[j].title == "Actions") {
                            StudentsDataGridCols[j].canShowColumn = true;
                        }
                    }
                }
            }
        }

    }

    return (
        <div className="row mt-3">
            {isIndividualStudent && <div className="col-md-10">
                <h2>Individual Students</h2>
            </div>}

            <div className="row" style={{ marginBottom: '15px', marginTop: '15px' }}>
                <div className="col-md-10">
                    <FormBuilder onUpdate={handleInput}>
                        <form ref={usersForm}>
                            <div className="row">
                                <div className="col-md-3">
                                    <input type="text" className="form-control ft-14" placeholder="Search name" name="name" />
                                </div>
                                <div className="col-md-3">
                                    <input type="text" className="form-control ft-14" placeholder="Search email" name="email_id" />
                                </div>
                                <div className="col-md-3">
                                    <select className="form-select ft-14" name="standard">
                                        <option value="">Select standard</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <select className="form-select  ft-14" name="division">
                                        <option value="">Select division</option>
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="C">C</option>
                                        <option value="D">D</option>
                                        <option value="E">E</option>
                                    </select>
                                </div>
                                <div className="col-md-3 mt-2">
                                    <select className="form-select ft-14" name="account_type">
                                        <option value="">Select account type</option>
                                        <option value="PAID">Paid</option>
                                        <option value="TRIAL">Trial</option>
                                    </select>
                                </div>
                                <div className="col-md-3 mt-2">
                                    <input type="text" className="form-control ft-14" placeholder="Custom search" name="search_name" />
                                </div>
                                <div className="col-md-3 mt-2">
                                    <select name="searchFilter" className="form-select ft-14" onChange={(e) => { handleFilterChange(e) }}>
                                        <option value="">Select filter</option>
                                        {filteredData.map((name: any, i: number) => (
                                            <option key={i} value={name.value}>
                                                {name.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </form>
                    </FormBuilder>
                </div>
                <div className="col-md-2 mt-5">
                    <button className="btn btn-primary px-3 cursor-pointer" type="button" onClick={() => handleSearch()}>Search</button>&nbsp;
                    <button className="btn clear-btn cursor-pointer" type="button" onClick={() => handleRefresh()}>
                        Clear
                    </button>
                </div>
            </div>

            {loading &&
                <div className="text-center p-5">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            }
            {!loading && <DataTable TableCols={StudentsDataGridCols} editInfo={onEditStudent}
                deleteInfo={onDeleteStudent}
                tableData={studentList} pageNumber={onPageChange}
                activePageNumber={activePage} pageNumbers={pageArray}></DataTable>}
        </div>
    )
}


